import * as React from "react"

import { SvgIconProps } from "styleguide/components/Svg/SvgIcon/SvgIcon"

import { Svg } from "styleguide/components"
import { uiColorToBaseColor } from "styleguide/styles/colors"

const IconStar = ({
  title = "Star",
  color = "darkestGray",
  viewBoxWidth = 24,
  viewBoxHeight = 22,
  isOutlined = false,
  ...otherProps
}: SvgIconProps & { isOutlined: boolean }) => (
  <Svg.Icon {...{ title, viewBoxHeight, viewBoxWidth, ...otherProps }}>
    <g
      id="1440-Star"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        transform="translate(-580.000000, -1432.000000)"
        fill={uiColorToBaseColor(color)}
      >
        <g id="Group-Star" transform="translate(160.000000, 1392.000000)">
          <polygon
            {...(isOutlined
              ? {
                  stroke: uiColorToBaseColor(color),
                  strokeWidth: "2",
                  strokeLinecap: "round",
                  strokeLinejoin: "round",
                  fill: "none",
                }
              : {})}
            id="Star-Copy"
            points="432 58 424.946577 61.7082039 426.293661 53.854102 420.587322 48.2917961 428.473288 47.145898 432 40 435.526712 47.145898 443.412678 48.2917961 437.706339 53.854102 439.053423 61.7082039"
          />
        </g>
      </g>
    </g>
  </Svg.Icon>
)

export default IconStar
